'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

require('./dashboard.scss');

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _grid = require('../components/grid.directive');

var _grid2 = _interopRequireDefault(_grid);

var _widget = require('../api/widget.service');

var _widget2 = _interopRequireDefault(_widget);

var _user = require('../api/user.service');

var _user2 = _interopRequireDefault(_user);

var _dashboard = require('../api/dashboard.service');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _customer = require('../api/customer.service');

var _customer2 = _interopRequireDefault(_customer);

var _detailsSidenav = require('../components/details-sidenav.directive');

var _detailsSidenav2 = _interopRequireDefault(_detailsSidenav);

var _widgetConfig = require('../components/widget/widget-config.directive');

var _widgetConfig2 = _interopRequireDefault(_widgetConfig);

var _dashboardSelect = require('../components/dashboard-select.directive');

var _dashboardSelect2 = _interopRequireDefault(_dashboardSelect);

var _relatedEntityAutocomplete = require('../components/related-entity-autocomplete.directive');

var _relatedEntityAutocomplete2 = _interopRequireDefault(_relatedEntityAutocomplete);

var _dashboard3 = require('../components/dashboard.directive');

var _dashboard4 = _interopRequireDefault(_dashboard3);

var _expandFullscreen = require('../components/expand-fullscreen.directive');

var _expandFullscreen2 = _interopRequireDefault(_expandFullscreen);

var _widgetsBundleSelect = require('../components/widgets-bundle-select.directive');

var _widgetsBundleSelect2 = _interopRequireDefault(_widgetsBundleSelect);

var _socialsharePanel = require('../components/socialshare-panel.directive');

var _socialsharePanel2 = _interopRequireDefault(_socialsharePanel);

var _types = require('../common/types.constant');

var _types2 = _interopRequireDefault(_types);

var _itemBuffer = require('../services/item-buffer.service');

var _itemBuffer2 = _interopRequireDefault(_itemBuffer);

var _importExport = require('../import-export');

var _importExport2 = _interopRequireDefault(_importExport);

var _layouts = require('./layouts');

var _layouts2 = _interopRequireDefault(_layouts);

var _states = require('./states');

var _states2 = _interopRequireDefault(_states);

var _dashboard5 = require('./dashboard.routes');

var _dashboard6 = _interopRequireDefault(_dashboard5);

var _dashboards = require('./dashboards.controller');

var _dashboard7 = require('./dashboard.controller');

var _dashboard8 = _interopRequireDefault(_dashboard7);

var _dashboardSettings = require('./dashboard-settings.controller');

var _dashboardSettings2 = _interopRequireDefault(_dashboardSettings);

var _addDashboardsToCustomer = require('./add-dashboards-to-customer.controller');

var _addDashboardsToCustomer2 = _interopRequireDefault(_addDashboardsToCustomer);

var _manageAssignedCustomers = require('./manage-assigned-customers.controller');

var _manageAssignedCustomers2 = _interopRequireDefault(_manageAssignedCustomers);

var _addWidget = require('./add-widget.controller');

var _addWidget2 = _interopRequireDefault(_addWidget);

var _dashboard9 = require('./dashboard.directive');

var _dashboard10 = _interopRequireDefault(_dashboard9);

var _editWidget = require('./edit-widget.directive');

var _editWidget2 = _interopRequireDefault(_editWidget);

var _dashboardToolbar = require('./dashboard-toolbar.directive');

var _dashboardToolbar2 = _interopRequireDefault(_dashboardToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.dashboard', [_angularUiRouter2.default, _types2.default, _itemBuffer2.default, _importExport2.default, _grid2.default, _widget2.default, _user2.default, _dashboard2.default, _customer2.default, _detailsSidenav2.default, _widgetConfig2.default, _dashboardSelect2.default, _relatedEntityAutocomplete2.default, _dashboard4.default, _expandFullscreen2.default, _widgetsBundleSelect2.default, _socialsharePanel2.default, _layouts2.default, _states2.default]).config(_dashboard6.default).controller('DashboardsController', _dashboards.DashboardsController).controller('DashboardCardController', _dashboards.DashboardCardController).controller('MakeDashboardPublicDialogController', _dashboards.MakeDashboardPublicDialogController).controller('DashboardController', _dashboard8.default).controller('DashboardSettingsController', _dashboardSettings2.default).controller('AddDashboardsToCustomerController', _addDashboardsToCustomer2.default).controller('ManageAssignedCustomersController', _manageAssignedCustomers2.default).controller('AddWidgetController', _addWidget2.default).directive('tbDashboardDetails', _dashboard10.default).directive('tbEditWidget', _editWidget2.default).directive('tbDashboardToolbar', _dashboardToolbar2.default).name;


// WEBPACK FOOTER //
// ./src/app/dashboard/index.js